module.exports = __webpack_public_path__ + "static/media/pobrezaygenero-780.6346bbf5.jpg";